import axios from '@axios'

export function ServiceStates() {
  this.getStates = () => new Promise((resolve, reject) => {
    try {
      axios.get('states/getStates')
        .then(resp => {
          resolve(resp.data)
        })
    } catch (error) {
      reject(error)
    }
  })
}
